/**
 * Use this when you need to handle potentially undefined booleans in conditional logic
 * @param bool potentially undefined boolean
 * @returns true if the bool is not undefined and true
 */
export function boolDefinedAndTrue(bool: boolean | undefined) {
  return typeof bool !== 'undefined' && bool;
}
